<nav class="section-menu" aria-label="Section menu">
  <ul class="section-menu-items">
    @for (menuEntry of menuEntries; track menuEntry.sectionId) {
      <li class="section-menu-item">
        <button
          type="button"
          class="section-button body-medium"
          [attr.data-section-id]="menuEntry.sectionId"
          (click)="onMenuItemClick(menuEntry.sectionId)"
        >
          {{ menuEntry.label }}
        </button>
      </li>
    }
  </ul>
</nav>
